import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPassword]',
  standalone: false,
})
export class AppPasswordDirective {
  private _shown = false;
  constructor(private el: ElementRef) {
    this.setup();
  }
  toggle(i: HTMLElement) {
    this._shown = !this._shown;
    const ssnElement = document.getElementById('cac-identification-ssn');
    if (this._shown) {
      ssnElement?.classList.remove('identity-ssn-masked');
      ssnElement?.setAttribute('type', 'text');
      i.classList.add('fa-eye');
      i.classList.remove('fa-eye-slash');
    } else {
      ssnElement?.classList.add('identity-ssn-masked');
      ssnElement?.setAttribute('type', 'password');
      i.classList.remove('fa-eye');
      i.classList.add('fa-eye-slash');
    }
  }
  setup() {
    const i = this.el.nativeElement;
    i.classList.add('fa-eye-slash');
    i.addEventListener('click', () => {
      this.toggle(i);
    });

    i.addEventListener('keypress', (e: { key: string }) => {
      if (e.key === 'Enter') this.toggle(i);
    });
  }
}
